import { render, staticRenderFns } from "./RemoteMonitoringTasks.vue?vue&type=template&id=94cf10c4"
import script from "./RemoteMonitoringTasks.vue?vue&type=script&lang=js"
export * from "./RemoteMonitoringTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports